//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import drawer from 'nges-common/src/web/components/drawer/index.vue';
import { PIPELINE_PLATFORM, PIPELINE_ENV } from '@/utils/constant.js';

export default {
  components: { drawer },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    detail: {
      type: Object,
      default: () => {},
    },
    tab: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      PIPELINE_PLATFORM,
      PIPELINE_ENV,
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
